import type { MessageKeys } from '@app-types/intl';
import { CaseSidebarSection, SectionPagesMap } from '../types';

export const CASE_SIDEBAR_SECTIONS: CaseSidebarSection[] = [
  CaseSidebarSection.DOCUMENTS,
  CaseSidebarSection.APPLICATION,
  CaseSidebarSection.OTHER,
];

export const SECTION_TITLE_KEYS: Record<CaseSidebarSection, MessageKeys> = {
  [CaseSidebarSection.DOCUMENTS]: 'caseSidebar.sections.documents',
  [CaseSidebarSection.APPLICATION]: 'caseSidebar.sections.application',
  [CaseSidebarSection.OTHER]: 'caseSidebar.sections.other',
};

export function createEmptySectionPagesMap(): SectionPagesMap {
  return {
    [CaseSidebarSection.DOCUMENTS]: [],
    [CaseSidebarSection.APPLICATION]: [],
    [CaseSidebarSection.OTHER]: [],
  };
}

export function cloneSectionPagesMap(pages: SectionPagesMap): SectionPagesMap {
  return {
    [CaseSidebarSection.DOCUMENTS]: [...pages[CaseSidebarSection.DOCUMENTS]],
    [CaseSidebarSection.APPLICATION]: [...pages[CaseSidebarSection.APPLICATION]],
    [CaseSidebarSection.OTHER]: [...pages[CaseSidebarSection.OTHER]],
  };
}
